import React from 'react';
import { Question, Serializer } from 'survey-core';
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui';
import ReCAPTCHA from 'react-google-recaptcha';
import { Box } from '@mui/material';

// Custom question model for CAPTCHA verification
class CaptchaModel extends Question {
  getType () {
    return 'captcha';
  }
}

// Register the question model with SurveyJS
Serializer.addClass(
  'captcha',
  [],
  function () {
    return new CaptchaModel('');
  },
  'question',
);

// React component for rendering
class CaptchaQuestion extends SurveyQuestionElementBase {
  constructor (props: any) {
    super(props);
    this.handleCaptchaToken = this.handleCaptchaToken.bind(this);
  }

  get question (): CaptchaModel {
    return this.props.question;
  }

  get value (): string | null {
    return this.question.value;
  }

  handleCaptchaToken (value: string | null) {
    this.question.value = value;
    // Trigger validation after changing the value (e.g. when the Captcha expires)
    this.question.validate();
  }

  render () {
    return (
      <Box>
        {/* Google reCAPTCHA Verification */}
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? ''}
          onChange={this.handleCaptchaToken}
        />
      </Box>
    );
  }
}

export const registerCaptchaQuestion = () => {
  // Register the React component
  ReactQuestionFactory.Instance.registerQuestion(
    'captcha',
    (props) => {
      return React.createElement(CaptchaQuestion, props);
    },
  );
};
